import {useQuery} from '@tanstack/react-query'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {getSummaryByUserId} from '../SummaryEndpoint'

export const useUserSummary = (requestorId, userId, enabled = true) => {
    const {summaryKeys} = QueryKeyManager(QueryKeyTypes.summary, requestorId)
    return useQuery({
        queryKey: summaryKeys.detailByUser({userId}),
        queryFn: () => getSummaryByUserId(userId),
        enabled: !!requestorId && !!userId,
    })
}
